import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_HOST;





export const getCustomPageMenu = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await axios.get(`${API_BASE_URL}/custom-page/customizables`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch custom pages", error);
    return null;
  }
};


export const addCustomPage = async (data) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/custom-page/add`, data, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getCustomPage = async ({ page = 1, limit = 10 }) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(`${API_BASE_URL}/custom-page`, {
      params: { page, limit },
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

    const resData = response.data.data;

    return {
      customPages: resData.data,
      currentPage: resData.current_page,
      lastPage: resData.last_page,
      perPage: resData.per_page,
      total: resData.total,
      nextPageUrl: resData.next_page_url,
      prevPageUrl: resData.prev_page_url,
    };
  } catch (error) {
    console.error("Failed to fetch custom pages", error);
    return null;
  }
};

export const updateCustom = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/custom-page/update`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getCustompageId = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/show/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const deleteCustomPageById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};






export const getFeaturesId = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/feature/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const deleteFeatureId = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/feature/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


export const addFeatureList = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/custom-page/feature/add`,
    data,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};


export const updateFeatureList = async (data) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.post(
    `${API_BASE_URL}/custom-page/feature/update`,
    data,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

export const getFeatureshowId = async (id) => {
  const token = localStorage.getItem("access_token");

  const response = await axios.get(
    `${API_BASE_URL}/custom-page/feature/show/${id}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );

  return response.data;
};


export const getGalleryListId = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/feature/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


export const getCustomGalleryId = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/gallery/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


export const getCustomDeleteGallery = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/gallery/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const addCustomPageGallery = async (data) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(
    `${API_BASE_URL}/custom-page/gallery/add`,
    data,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};


export const getCustomShowGallery = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/custom-page/gallery/show/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const updateCustomPageGallery = async (data) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(
    `${API_BASE_URL}/custom-page/gallery/update`,
    data,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};


